import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { loginRouting } from './login.routing';
import { LoginGuard } from './login.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { MatSelectModule } from '@angular/material';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { LoginService } from './login.service';
import { ChangePasswordComponent } from './change-password.component';
import { SharedModule } from '../core/shared/shared.module';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { WINDOW_PROVIDERS } from './reset-password/window.provider';


@NgModule({
  imports: [
    loginRouting,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    HttpClientModule,
    HttpModule,
    SharedModule
  ],

  declarations: [LoginComponent, ChangePasswordComponent, ResetPasswordComponent],
  providers: [LoginService, LoginGuard, WINDOW_PROVIDERS],
})
export class LoginModule {
}
